<template>
  <v-flex xs12 sm6>
    <v-card class="pa-2">
      <v-card-title primary-title>
        <v-container fluid>
          <v-layout column align-center>
            <v-flex xs12>
              <v-icon x-large primary>lock</v-icon>
            </v-flex>
            <v-flex xs12>
              <span class="headline">Autentificare</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-text-field ref="email" :rules="[rules.required, rules.email]" type="email" name="email" label="Email" id="email" v-model="email" prepend-icon="email" hint="email" @keyup.native.enter="login"></v-text-field>
        <v-text-field ref="password" :rules="[rules.required]" :type="showPassword ? 'text' : 'password'" name="password" label="Parola" id="password" v-model="password" prepend-icon="vpn_key" hint="parola" @keyup.native.enter="login" :append-icon="showPassword ? 'visibility' : 'visibility_off'" :append-icon-cb="toggleShowPassword"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat primary @click.native="login">Autentifica-te</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    data () {
      return {
        showPassword: false,
        email: '',
        password: '',
        rules: {
          required: (value) => !!value || 'Camp obligatoriu!',
          email: (value) => {
            /* eslint-disable no-useless-escape */
            const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail invalid!'
          }
        }
      }
    },
    computed: {
      light () {
        return this.$store.getters.appLight
      }
    },
    methods: {
      toggleShowPassword () {
        this.showPassword = !this.showPassword
      },
      login () {
        if (!this.$refs.email.hasError && !this.$refs.password.hasError) {
          this.$store.dispatch('login', {email: this.email.toLowerCase(), password: this.password})
            .then(() => {
              let user = this.$store.getters.getUser
              if (user) {
                this.email = ''
                this.password = ''
                if (user.admin) {
                  this.$router.push({name: 'Dashboard'})
                } else {
                  this.$router.push({name: 'Index'})
                }
              }
            })
        }
      }
    },
    created () {
      this.login = this.$throttle(this.login, 1000, { leading: true, trailing: false })
    },
    beforeRouteLeave (to, from, next) {
      this.email = ''
      this.password = ''
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?31bde3a4